export enum GefahrengruppenEnum {
  A = "A",
  B = "B",
  AB = "AB",
  K = "K",
  U = "U",
  S = "S",
}
